import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import hamburgerIcon from '../../asset/img/common/hamburger_icon.svg';
import headerProgressIcon from '../../asset/img/header_progress_icon.svg';
import headerArrowRightIcon from '../../asset/img/header_arrow_right_icon.svg';
import headerPartyPopperIcon from '../../asset/img/header_party_popper_icon.png';

import { useLocation, useNavigate } from 'react-router-dom';
import { deductionHeaderOptions, progressHeaderOptions } from '../../common/data';
import { checkHouseNextFunction } from '../../common/Util';
import { useDispatch, useSelector } from 'react-redux';
import MenuSlide from '../MenuSlide';

const HeaderStyled = styled.div`
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  background-color: #fff;
  position: sticky;
  border-bottom: 1px solid var(--GrayScale-400);
  top: 0;
  z-index: 100;
  .stepIcon {
    padding: 9px;
  }
`;

//진행상태 헤더
const ProgressHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { t: tLogin } = useTranslation('login');
  const { t: tCommon } = useTranslation('common');

  const { isCertify, isMagam } = useSelector(state => state.common);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  let menuList = progressHeaderOptions(tCommon);
  let deductionMenuList = deductionHeaderOptions(tCommon);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // 컴포넌트 언마운트 시 스크롤 상태 복구
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  let nextPath = () => {
    let nextPath = '';
    menuList.forEach((menu, index) => {
      if (pathname.includes('deductions')) {
        console.log('deductions >');
        deductionMenuList.forEach((deductionMenu, deductionIndex) => {
          if (pathname.includes(deductionMenu.path)) {
            if (deductionMenuList[deductionIndex + 1]) {
              nextPath = deductionMenuList[deductionIndex + 1].path;
            } else {
              nextPath = '/evidenceDocuments';
            }
          }
        });
      } else {
        if (pathname.includes(menu.checkPath)) {
          nextPath = menuList[index + 1].movePath;
        }
      }
    });

    return nextPath;
  };

  const nextButtonHandler = nextPath => {
    // 체크할 경로 리스트
    const pathList = ['deductions', 'evidenceDocuments', 'resultQuery'];

    // pathList의 요소 중 하나라도 현재 pathname에 포함되어 있는지 확인
    const isIncludedPath = pathList.some(path => nextPath.includes(path));
    if (isIncludedPath) {
      checkHouseNextFunction(dispatch, tCommon, navigate, nextPath, isMagam, isCertify);
    } else {
      navigate(nextPath);
    }
  };

  const clickHamburgerHandler = () => {
    setIsMenuOpen(true);
  };

  return (
    <HeaderStyled>
      {isCertify && <img src={hamburgerIcon} alt="전체메뉴열기" onClick={clickHamburgerHandler} />}

      {/* 햄버거 누를때 나오는거 */}
      <MenuSlide isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

      {menuList.map((menu, index) =>
        pathname.includes(menu.checkPath) ? (
          <div key={index}>{menu.label}</div>
        ) : (
          <img
            key={index}
            className="stepIcon"
            src={headerProgressIcon}
            alt={menu.label}
            onClick={() => nextButtonHandler(menu.movePath)}
          />
        ),
      )}
      {!pathname.includes('resultQuery') ? (
        <img
          src={headerArrowRightIcon}
          alt="다음으로"
          onClick={() => nextButtonHandler(nextPath())}
        />
      ) : (
        <img src={headerPartyPopperIcon} alt="파티이미지" />
      )}
    </HeaderStyled>
  );
};

export default ProgressHeader;
